import BrowsersIcon from 'assets/icons/browsers-icon.png';
import DeviceSettingsIcon from 'assets/icons/device-settings.svg';
import CameraDisableIcon from 'assets/ver2/icons/camera-disable-icon.svg';
import ButtonCommon from 'components/common/ButtonCommon';
import SizeBox from 'components/common/SizeBox';
import {
  DESKTOP_MIN_WIDTH,
  HHMT_EMAIL,
  HHMT_PHONE,
  HHMT_PHONE_2,
  REMOX_EMAIL,
  REMOX_PHONE,
  REMOX_PHONE_2,
} from 'constants';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useLang from 'hooks/useLang';
import useTheme from 'hooks/useTheme';
import Modal from 'react-bootstrap/Modal';
import styled from 'styled-components';
import {
  displayFlexRowCenterStartMixin,
  fontSize14Mixin,
  fontSize16Mixin,
  paragraph500Mixin,
  paragraph700Mixin,
  scrollbarThumbMixin,
} from 'styles';

const CheckCameraToTakePhotoEnableAlertPopup = ({
  isOpen,
  onClose,
  isBackdropOverlap,
  zIndexBackdropOverlap,
  zIndexModal,
}) => {
  const { t } = useLang();
  const { isHHMTTheme } = useTheme();
  const { isDesktop } = useDetectDevice();

  const renderSettingSteps = () => {
    if (isDesktop)
      return (
        <>
          <Paragraph
            dangerouslySetInnerHTML={{
              __html: t(
                'popup_check_camera_to_take_photo_enable_alert_step_1_desktop'
              ),
            }}
          />
          <SizeBox height={16} />
          <Paragraph
            dangerouslySetInnerHTML={{
              __html: t(
                'popup_check_camera_to_take_photo_enable_alert_step_2_desktop'
              ),
            }}
          />
          <SizeBox height={16} />
          <Paragraph
            dangerouslySetInnerHTML={{
              __html: t(
                'popup_check_camera_to_take_photo_enable_alert_step_3_desktop'
              ),
            }}
          />
        </>
      );
    return (
      <>
        <Paragraph
          dangerouslySetInnerHTML={{
            __html: t('popup_check_camera_to_take_photo_enable_alert_step_1'),
          }}
        />
        <SizeBox height={8} />
        <Image src={DeviceSettingsIcon} />
        <SizeBox height={16} />
        <Paragraph
          dangerouslySetInnerHTML={{
            __html: t('popup_check_camera_to_take_photo_enable_alert_step_2'),
          }}
        />
        <SizeBox height={8} />
        <Image src={BrowsersIcon} />
        <SizeBox height={16} />
        <Paragraph
          dangerouslySetInnerHTML={{
            __html: t('popup_check_camera_to_take_photo_enable_alert_step_3'),
          }}
        />
      </>
    );
  };

  const renderContactInfoDesc = () => {
    if (isDesktop)
      return (
        <ContactInfoDesc
          dangerouslySetInnerHTML={{
            __html: t(
              'popup_check_camera_to_take_photo_enable_alert_contact_us_desktop',
              {
                email: isHHMTTheme ? HHMT_EMAIL : REMOX_EMAIL,
                phone1: isHHMTTheme ? HHMT_PHONE : REMOX_PHONE,
                phone2: isHHMTTheme ? HHMT_PHONE_2 : REMOX_PHONE_2,
              }
            ),
          }}
        />
      );
    return (
      <ContactInfoDesc
        dangerouslySetInnerHTML={{
          __html: t(
            'popup_check_camera_to_take_photo_enable_alert_contact_us',
            {
              email: isHHMTTheme ? HHMT_EMAIL : REMOX_EMAIL,
              phone1: isHHMTTheme ? HHMT_PHONE : REMOX_PHONE,
              phone2: isHHMTTheme ? HHMT_PHONE_2 : REMOX_PHONE_2,
            }
          ),
        }}
      />
    );
  };

  return (
    <>
      <style>
        {zIndexModal
          ? `
          .check-camera-to-take-photo-enable-alert-modal {
            z-index: ${zIndexModal || 1101};
          }
        `
          : ``}

        {isBackdropOverlap
          ? `
          .check-camera-to-take-photo-enable-alert-modal-backdrop {
            z-index: ${zIndexBackdropOverlap || 1100}!important;
            background: #212121;
            opacity: 0.7!important;
            display: initial!important;
          }
        `
          : `
        .check-camera-to-take-photo-enable-alert-modal-backdrop {
          background: #212121;
          opacity: 0.7!important;
          display: initial!important;
        }
      `}
      </style>
      <ModalStyled
        show={isOpen}
        onHide={() => {}}
        aria-labelledby="contained-modal-title-vcenter"
        className="check-camera-to-take-photo-enable-alert-modal"
        backdropClassName="check-camera-to-take-photo-enable-alert-modal-backdrop"
        centered
      >
        <ModalBody>
          <Title>
            <img src={CameraDisableIcon} width={24} height={24} />
            {t('popup_check_camera_to_take_photo_enable_alert_title')}
          </Title>
          <SizeBox height={16} />
          <Paragraph>
            {t('popup_check_camera_to_take_photo_enable_alert_desc')}
          </Paragraph>
          <SizeBox height={16} />
          {renderSettingSteps()}
          <SizeBox height={16} />
          {renderContactInfoDesc()}
          <SizeBox height={16} />
        </ModalBody>
        <ActionButtons>
          <ButtonCommon
            value={t('button_close')}
            color="var(--c-primary)"
            background="var(--bg-primary)"
            isFill={true}
            styles={{
              margin: '0px',
              paddingInline: '29px',
              height: '44px',
              width: 'fit-content',
            }}
            onClick={onClose}
            isUseKeyDown
          />
        </ActionButtons>
      </ModalStyled>
    </>
  );
};

const ModalStyled = styled(Modal)`
  & .modal-dialog {
    max-width: fit-content;
    tranform: none;
  }

  & .modal-content {
    padding: 16px 10px;
    border-radius: 12px;
    box-shadow: var(--ds-bs-4);
    background: var(--ds-c-white);
    max-width: 480px;
    height: fit-content;
    max-height: calc(dvh - 80px);
    margin-inline: auto;
    border: none;
    overflow-y: scroll;
    ${scrollbarThumbMixin};
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    & .modal-content {
      height: fit-content;
    }
  }
`;

const ModalBody = styled(Modal.Body)`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  text-align: left;

  padding: 0;
  margin-bottom: 0px;
`;

const Title = styled.p`
  ${paragraph700Mixin};
  ${displayFlexRowCenterStartMixin};
  gap: 4px;
`;
const Paragraph = styled.p`
  ${paragraph500Mixin};
`;

const Image = styled.img`
  height: 45px;
`;

const ActionButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  width: 100%;
`;

const ContactInfoDesc = styled.p`
  ${paragraph500Mixin};
  ${fontSize14Mixin};
  padding: 8px;
  background: #f5fff8;
  color: #09714b;

  & a {
    text-decoration: none;
    color: var(--ds-c-blue-hyperlink-default);
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    ${fontSize16Mixin};
  }
`;

export default CheckCameraToTakePhotoEnableAlertPopup;
